<template>
    <div style="padding: 15px 0; margin-bottom: 15px; border-bottom: 1px solid #efefef;">
        <div class="title">{{number}}. {{title}}</div>
        <div style="">
            <div style="color: #707070; font-size: 15px;">{{avtor}}</div>
            <div style="font-size: 14px; color:#929292; padding: 10px 0;"><slot></slot></div>
        </div>
        <div style="font-size: 15px; color: #48748a">
            <div v-if="code"><strong style="color: #000;">Шифр:</strong> {{code}}</div>
            <div v-if="year"><strong style="color: #000;">Год:</strong> {{year}}</div>
            <div v-if="search"><strong style="color: #000;">Найдено:</strong> {{search}}</div>
            <div v-if="seria"><strong style="color: #000;">Серия:</strong> {{seria}}</div>
            <div v-if="theme"><strong style="color: #000;">Тема:</strong> {{theme}}</div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            number: String,
            title: String,
            avtor: String,
            year: String,
            code: String,
            search: String,
            seria: String,
            theme: String
        }
    }
</script>
